import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import Title from '../../../components/Headers/Title';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { LicenseProps } from '../../../types/IdProps';
import DataService from "../../../services/data.service";
import { useNotifications } from '../../../contexts/notificationContext';
import AddRegionPopup from '../Popups/License_popup_AddRegion';
import AddCountryPopup from '../Popups/License_popup_AddCountry';

const License_tab_Regions: React.FC<LicenseProps> = ({ licenseId }) => {
    const [includedRegionData, setIncludedRegionData] = useState<any[]>();
    const [excludedRegionData, setExcludedRegionData] = useState<any[]>();
    const [includedCountryData, setIncludedCountryData] = useState<any[]>();
    const [excludedCountryData, setExcludedCountryData] = useState<any[]>();
    const [includedRegion, setIncludedRegion] = useState<boolean>(false)
    const [includedCountry, setIncludedCountry] = useState<boolean>(false)
    const [showRegionPopup, setShowRegionPopup] = useState<boolean>(false)
    const [showCountryPopup, setShowCountryPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedFor } = useAuth();

    useEffect(() => {
        getRegionTableData();
        getCountryTableData();
    }, [licenseId]);

    function getRegionTableData() {
        DataService.get<any[]>('api/v1/LicenseRegions/ByLicenseIncluded/' + licenseId)
            .then(response => {
                setIncludedRegionData(response);
            })
            .catch(e => { handleException(e); });

        DataService.get<any[]>('api/v1/LicenseRegions/ByLicenseExcluded/' + licenseId)
            .then(response => {
                setExcludedRegionData(response);
            })
            .catch(e => { handleException(e); });

    }

    function getCountryTableData() {
        DataService.get<any[]>('api/v1/LicenseCountries/ByLicenseIncluded/' + licenseId)
            .then(response => {
                setIncludedCountryData(response);
            })
            .catch(e => { handleException(e); });

        DataService.get<any[]>('api/v1/LicenseCountries/ByLicenseExcluded/' + licenseId)
            .then(response => {
                setExcludedCountryData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRegionRow(rowData) {
        DataService.delete('api/v1/LicenseRegions/', rowData.id)
            .then(response => {
                handleResult(response);
                getRegionTableData();
            })
            .catch(e => { handleException(e); });
    }

    function deleteCountryRow(rowData) {
        DataService.delete('api/v1/LicenseCountries/', rowData.id)
            .then(response => {
                handleResult(response);
                getCountryTableData();
            })
            .catch(e => { handleException(e); });
    }

    const includedRegionInfos: IColInfo[] = [
        { key: true, dataProp: 'regionId', visible: false },
        { title: 'Region', dataProp: 'regionNameTree', sort: 'asc' },
    ];

    const excludedRegionInfos: IColInfo[] = [
        { key: true, dataProp: 'regionId', visible: false },
        { title: 'Region', dataProp: 'regionNameTree', sort: 'asc' },
    ];

    const includedCountryInfos: IColInfo[] = [
        { key: true, dataProp: 'countryId', visible: false },
        { title: 'Country', dataProp: 'countryName', sort: 'asc' },
    ];

    const excludedCountryInfos: IColInfo[] = [
        { key: true, dataProp: 'countryId', visible: false },
        { title: 'Country', dataProp: 'countryName', sort: 'asc' },
    ];

    if (isAuthorizedFor(ApplicationFunctions.UpdateLicense)) {
        includedRegionInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => { setIncludedRegion(true); setShowRegionPopup(true); } }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRegionRow }]
            });

        excludedRegionInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => { setIncludedRegion(false); setShowRegionPopup(true); } }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRegionRow }]
            });

        includedCountryInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => { setIncludedCountry(true); setShowCountryPopup(true); } }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteCountryRow }]
            });

        excludedCountryInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => { setIncludedCountry(false); setShowCountryPopup(true); } }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteCountryRow }]
            });
    }

    return (
        <Container fluid>
            <Row>
                <Col md='6'>
                    <Title size={4} text='Included' />
                    <Row>
                        <Col md='6'>
                            <DataTable
                                name='dtLicenseIncludedRegions'
                                colInfos={includedRegionInfos}
                                tableData={includedRegionData}
                                navigateTitle={'Region'}
                                navigateUrl={'/plm/ItemSetup/Region/'}
                            />
                        </Col>
                        <Col md='6'>
                            <DataTable
                                name='dtLicenseIncludedCountries'
                                colInfos={includedCountryInfos}
                                tableData={includedCountryData}
                                navigateTitle={'Country'}
                                navigateUrl={'/plm/ItemSetup/Country/'}
                            />
                        </Col>
                    </Row>
                </Col>
                <Col md='6'>
                    <Title size={4} text='Excluded' />
                    <Row>
                        <Col md='6'>
                            <DataTable
                                name='dtLicenseExcludedRegions'
                                colInfos={excludedRegionInfos}
                                tableData={excludedRegionData}
                                navigateTitle={'Region'}
                                navigateUrl={'/plm/ItemSetup/Region/'}
                            />
                        </Col>
                        <Col md='6'>
                            <DataTable
                                name='dtLicenseExcludedCountries'
                                colInfos={excludedCountryInfos}
                                tableData={excludedCountryData}
                                navigateTitle={'Country'}
                                navigateUrl={'/plm/ItemSetup/Country/'}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>

            {showRegionPopup && <AddRegionPopup licenseId={licenseId} included={includedRegion} show={showRegionPopup} onHide={() => { setShowRegionPopup(false); getRegionTableData(); }} />}
            {showCountryPopup && <AddCountryPopup licenseId={licenseId} included={includedCountry} show={showCountryPopup} onHide={() => { setShowCountryPopup(false); getCountryTableData(); }} />}
        </Container>

    );
}
export default License_tab_Regions;